// React
import * as React from 'react';

// Router
import { Link } from 'react-router-dom';

// Redux
import { connect } from 'react-redux';

// Components
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import BarcodeScan from './Icons/BarcodeScan';

interface Props {
    anchorEl: any;
    handleClose: any;
    id: any;
    urlPath: any;
    handleClickAvailability: any;
    handleClickBarcode: any;
}

interface State {
    actualId: any;
}

/**
 * @description AvailabilityModal View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect<{}, {}, Props>((state) => state)(class AvailabilityModal extends React.Component<Props, State> {

    /**
     * Creates an instance of AvailabilityModal.
     * @author Lucas Fridez <lucas@fridez.dev>
     * @param {*} props
     * @memberof App
     */
    constructor(props: any) {
        super(props);
        this.state = {
            actualId: 0
        };
    }

    componentWillReceiveProps(nextProps: Props, a: any) {
        this.setState({
            actualId: nextProps.id
        });
    }

    /**
     * @description Render the AvailabilityModal in the Browser
     * @author Lucas Fridez <lucas@fridez.dev>
     * @returns
     * @memberof App
     */
    public render() {
        const { anchorEl, handleClose, id, urlPath, handleClickAvailability, handleClickBarcode } = this.props;
        const { actualId } = this.state;
        return (
            <Menu
                id={actualId}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                PaperProps={{
                    elevation: 0,
                    style: {
                        boxShadow: "0 12px 20px -10px rgba(150, 150, 150, 0.28), 0 4px 20px 0px rgba(150, 150, 150, 0.12), 0 7px 8px -5px rgba(150, 150, 150, 0.2)",
                        maxWidth: 150
                    }
                }}
            >
                <MenuItem>
                    <Link to={`${urlPath}/Afficher/${actualId}`} className="flex-hr">
                        <Typography className="list-text flex-hr"><Icon>remove_red_eye</Icon> <span>Afficher</span></Typography>
                    </Link>
                </MenuItem>
                <MenuItem onClick={(e) => handleClickAvailability(e, id)}>
                    <Typography className="list-text flex-hr"><Icon>warning</Icon> Disponibilité</Typography>
                </MenuItem>
                <MenuItem onClick={handleClickBarcode}>
                    <Typography className="list-text flex-hr"><BarcodeScan /> Code barre</Typography>
                </MenuItem>
            </Menu>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/components/ActionsMenu.tsx